/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../app/constants/events';
import { HEROKU_BOOMERANG_BAR_HEIGHT } from '../../../app/constants/app';

xplenty.service('modalService', [
  '$rootScope',
  '$compile',
  '$timeout',
  '$window',
  '$translate',
  '$location',
  '$state',
  'NavigationHotkeys',

  function ($rootScope, $compile, $timeout, $window, $translate, $location, $state, NavigationHotkeys) {
    const modalService = {};

    let $modal;
    let stateChangeSuccessListner;

    modalService.showModal = function (options, directive, scope) {
      const defaults = {
        backdrop: 'static',
        keyboard: false,
        escape: true,
        hasPadding: true,
        hasFooter: true,
        hasScroll: true,
        autoInputFocus: true,
        show: false,
        size: 'large',
        titleText: '',
        descriptionText: '',
        closeButtonText: 'Close',
        saveButtonHidden: false,
        saveButtonText: 'Save changes',
        icon: '',
        target: null,
        offset: {
          top: 0,
          left: 0,
        },
        afterCompile() {},
        onClose() {},
        onCancel() {},
        onSave() {},
        beforeClose() {},
      };
      if (options) angular.extend(defaults, options);

      // eslint-disable-next-line global-require
      const modalTemplate = require('../../../views/modal.html');
      $modal = angular.element(modalTemplate);
      if (stateChangeSuccessListner) {
        stateChangeSuccessListner();
      }

      const $dialog = $modal.find('.modal-dialog');
      const $title = $modal.find('.modal-title');
      const $description = $modal.find('.modal-description');
      const $header = $modal.find('.modal-header');
      const $body = $modal.find('.modal-body');
      const $footer = $modal.find('.modal-footer');
      const $closeBtn = $modal.find('.modal-btn-close');
      const $backBtn = $modal.find('.modal-btn-back');
      const $saveBtn = $modal.find('.modal-btn-save');
      const $extraBtn = $modal.find('.modal-btn-extra');
      const $helpLink = $modal.find('.modal-help-link');
      const $svgIcon = $modal.find('.modal-icon');
      const $svgIconUse = $modal.find('.modal-icon-use');

      $title.text($translate.instant(defaults.titleText));
      $description.text($translate.instant(defaults.descriptionText));
      $closeBtn.find('span').text($translate.instant(defaults.closeButtonText));
      $saveBtn.text($translate.instant(defaults.saveButtonText));

      if (defaults.saveButtonHidden) {
        $saveBtn.hide();
      }

      if (defaults.extraButtonText) {
        $extraBtn.text($translate.instant(defaults.extraButtonText));
      } else {
        $extraBtn.hide();
      }

      if (!defaults.descriptionText || defaults.descriptionText.length === 0) {
        $description.remove();
      } else {
        $footer.addClass('has-description');
      }

      if (defaults.icon && defaults.icon.length > 0) {
        $svgIconUse.attr('href', `#icons-sprite_${defaults.icon}`);
        $footer.addClass('has-icon');
        $title.attr('contenteditable', 'true');
      } else {
        $svgIcon.remove();
      }

      if (defaults.helpLinkText && defaults.helpLinkUrl) {
        $helpLink.text(defaults.helpLinkText).attr({
          href: defaults.helpLinkUrl,
          target: '_blank',
        });
      } else {
        $helpLink.hide();
      }

      if (!defaults.hasFooter) {
        $footer.hide();
      }

      if (defaults.size === 'large') $dialog.addClass('modal-lg');
      if (defaults.size === 'small') $dialog.addClass('modal-sm');

      if (directive && scope) {
        $body.append($compile(directive)(scope));
        $timeout(defaults.afterCompile);
      }

      if (!defaults.hasPadding) {
        $body.addClass('no-padding');
      }

      if (defaults.thin) {
        $modal.addClass('thin');
      }

      if ($('body').hasClass('heroku-boomerang-loaded')) {
        $modal.css('top', HEROKU_BOOMERANG_BAR_HEIGHT);
      }

      $modal.modal(defaults);

      $timeout(function () {
        $modal.modal('show');
      });

      const $backdrop = angular.element('.modal-backdrop');
      $backdrop.removeClass('in');
      $backdrop.addClass('absolute');

      const css = {
        top: 0,
        left: 0,
      };
      css.top += defaults.offset.top;
      css.left += defaults.offset.left;
      css.width = 140;
      css.height = 80;
      css.opacity = 0;
      $backdrop.css(css);

      $backdrop.addClass('animate');
      $backdrop.css({
        opacity: 1,
        top: 0,
        left: 0,
        width: $window.innerWidth,
        height: $window.innerHeight,
      });

      const resize = function () {
        const headerHeight = $header.outerHeight();
        const footerHeight = $footer.outerHeight();
      };

      angular.element($window).on('resize', resize);

      if (defaults.hasScroll) $body.perfectScrollbar();

      $modal.on('hide.bs.modal', defaults.beforeClose);

      $modal.on('show.bs.modal', function () {
        // Pause any hot keys
        // Make sure to not get into racecondition with state change events. Timeout to the rescue.
        $timeout(function () {
          NavigationHotkeys.pause();
        });
      });

      $modal.on('shown.bs.modal', function () {
        if (defaults.autoInputFocus) {
          const _this = this;
          $timeout(function () {
            $('input:visible:first', _this).focus();
          });
        }
      });

      $modal.on('hidden.bs.modal', function () {
        // Make sure to not get into racecondition with state change events. Timeout to the rescue.
        $timeout(function () {
          NavigationHotkeys.unpause();
        });
        $rootScope.$broadcast(EVENTS.MODAL_PANEL_CLOSE_CLICK);
        defaults.onClose();
        $modal.remove();
      });

      $rootScope.$on(EVENTS.MODAL_CLOSE, function () {
        $modal.modal('hide');
      });

      $saveBtn.on('click', function () {
        $rootScope.$broadcast(EVENTS.MODAL_PANEL_SAVE_CLICK);

        defaults.onSave();
      });

      $closeBtn.on('click', function () {
        defaults.onCancel();
      });

      $timeout(function () {
        resize();
      }, 200);

      $modal.enableSaveButton = function (buttonEnabled) {
        $saveBtn.attr('disabled', !buttonEnabled);
      };

      $modal.hideModal = function () {
        $modal.modal('hide');
        if (stateChangeSuccessListner) stateChangeSuccessListner();
      };

      $modal.loading = function (loading) {
        if (loading) {
          $saveBtn.addClass('loading');
        } else {
          $saveBtn.removeClass('loading');
        }

        $saveBtn.attr('disabled', loading);
      };

      const checkJobChildren = function (state) {
        if (state.name.indexOf('app.account.jobs.item.children') > -1) {
          $backBtn.show();
        } else {
          $backBtn.hide();
        }
      };

      stateChangeSuccessListner = $rootScope.$on('$stateChangeSuccess', function (
        event,
        toState,
        toParams,
        fromState,
        fromParams,
      ) {
        console.log('MODAL:', toState.name);
        checkJobChildren(toState);
      });

      $backBtn.on('click', function () {
        $state.go('app.account.jobs.item.tasks');
      });

      checkJobChildren($state.current);

      return $modal;
    };

    modalService.enableSaveButton = function (buttonEnabled) {
      if (!$modal) return;
      $modal.enableSaveButton(buttonEnabled);
    };

    modalService.hideModal = function () {
      if ($modal) $modal.modal('hide');
    };

    modalService.isVisible = function () {
      return $modal && $modal.is(':visible');
    };

    return modalService;
  },
]);
